import {
    HOME,
    PLATFORM_OPTIONS,
    USERS_ROLES,
    GROUPS,
    ACCOUNT,
    THEMES,
    SECURITY,
    DATA_ACCESS,
    INTEGRATIONS,
    SUBSCRIPTION_INVOICES,
    NOTIFICATIONS,
    SOCIAL_PROFILES,
    REPORTS,
    DASHBOARD,
    CONTENT_ALBUM_POSTS,
    CONTENT_ALBUM_ANALYTICS,
    SCHEDULER_COLLABORATION_SETTINGS,
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    MEDIA,
    ICO_ACADEMY
} from '@/lib/routes/privateRoutes';

export const layoutHeaderDisabled = [
    HOME,
    NOTIFICATIONS,
    GROUPS,
    SOCIAL_PROFILES,
    REPORTS,
    // Dashboard
    DASHBOARD,
    // PUBLISHING
    SCHEDULER_COLLABORATION_SETTINGS,
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    // SETTINGS
    PLATFORM_OPTIONS,
    USERS_ROLES,
    ACCOUNT,
    THEMES,
    SECURITY,
    DATA_ACCESS,
    INTEGRATIONS,
    SUBSCRIPTION_INVOICES,
    CONTENT_ALBUM_POSTS,
    CONTENT_ALBUM_ANALYTICS,
    // MEDIA
    MEDIA,
    // ICO ACADEMY
    ICO_ACADEMY
];
